import React from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Grid, Tooltip, IconButton } from '@material-ui/core';
import { Filters, PaginatedFilters, RegexFilter, QueryFilter, AutoCompleteCheckbox, AutoCompleteRadioFilter, DateRangeFilter } from 'components';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
  filterButton: {
    margin: '0px 8px',
    fontWeight: 'normal',
    color: 'rgba(0,0,0,.55) !important',
    opacity: '1 !important',
    '&:hover': {
      color: theme.palette.primary.main + '!important'
    }
  },
  innerGrid: {
    display: 'flex',
    alignItems: 'center',
  },
  filters: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: '1'
  }
}));

export default function FilterBar(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { filterOptions, action, selection } = props;

  const reset = () => {
    filterOptions.resetFilters();
    if (selection) {
      selection(false);
    }
    dispatch(action);
  };

  return (
    <>
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <div className={classes.innerGrid}>
            <div className={classes.filters}>
              {filterOptions.filters?.length > 0 &&
                filterOptions.filters.map(filter => {
                  return <Filters filter={filter} action={action} />;
                })}
              {filterOptions.paginatedFilter?.length > 0 &&
                filterOptions.paginatedFilter.map(filter => {
                  return <PaginatedFilters filter={filter} action={action} />;
                })}
              {filterOptions.autocompleteSearch && (
                <AutoCompleteCheckbox
                  filter={filterOptions.autocompleteSearch}
                  action={action}
                  showStatusFilter={filterOptions.autocompleteSearch.showStatusFilter}
                  statusFilter={filterOptions.autocompleteSearch.statusFilter}
                  onStatusChange={filterOptions.autocompleteSearch.onStatusChange}
                />
              )}
              {filterOptions.autocompleteRadioSearch && (
                <AutoCompleteRadioFilter
                  filter={filterOptions.autocompleteRadioSearch}
                  action={action}
                  showStatusFilter={filterOptions.autocompleteRadioSearch.showStatusFilter}
                  statusFilter={filterOptions.autocompleteRadioSearch.statusFilter}
                  onStatusChange={filterOptions.autocompleteRadioSearch.onStatusChange}
                />
              )}
              {filterOptions.dateRangeFilters && (
                <DateRangeFilter 
                  filtersOptions={filterOptions.dateRangeFilters} action={action} storeSelector={filterOptions.storeSelector}
                />
              )}
              {filterOptions.regexFilters?.length > 0 && (
                filterOptions.regexFilters.map(filter => {
                  return <RegexFilter filter={filter} action={action} validation={filterOptions.validation}/>;
                })
              )}
              {filterOptions.queryFilters && (
                <QueryFilter
                  filter={filterOptions.queryFilters}
                  action={action}
                />
              )}
              {filterOptions.customFilters?.length > 0 &&
                filterOptions.customFilters.map((customFilter, index) => (
                  <div key={`custom-filter-${index}`} style={{ marginLeft: '8px' }}>
                    {customFilter.component}
                  </div>
                ))}
            </div>
            {typeof filterOptions.resetFilters === 'function' && (
              <Tooltip title="Reset and dismiss filters">
                <IconButton
                  variant="outlined"
                  className={classes.filterButton}
                  onClick={reset}>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            )}
          </div>
        </Grid>
      </Grid>
    </>
  );
}
